import { render } from "./PartnerPetal.vue?vue&type=template&id=0d5018ca"
import script from "./PartnerPetal.vue?vue&type=script&lang=js"
export * from "./PartnerPetal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__